/**
 * Parses product nutritional metafield text into label/value rows.
 * Supports newline-separated lines and single-line " : " delimited data.
 */
(function () {
  function parseLine(line) {
    const colonIndex = line.indexOf(':');
    if (colonIndex === -1) {
      return null;
    }
    return {
      label: line.slice(0, colonIndex).trim(),
      value: line.slice(colonIndex + 1).trim(),
    };
  }

  function parseSingleLine(text) {
    const parts = text.split(' : ').map(function (part) {
      return part.trim();
    });
    const rows = [];
    let label = parts[0];
    const labelPattern = /^(.+?)\s+((?:OF WHICH )?[A-Z][A-Z0-9\s()]+)$/;

    for (let i = 1; i < parts.length; i += 1) {
      const segment = parts[i];

      if (i === parts.length - 1) {
        rows.push({ label: label, value: segment });
        break;
      }

      const match = segment.match(labelPattern);
      if (match) {
        rows.push({ label: label, value: match[1].trim() });
        label = match[2].trim();
      } else {
        rows.push({ label: label, value: segment });
        label = '';
      }
    }

    return rows;
  }

  function parseNutrition(text) {
    if (!text) return [];

    const normalized = String(text).replace(/\r\n/g, '\n').trim();
    const lines = normalized.split('\n').map(function (line) {
      return line.trim();
    }).filter(Boolean);

    if (lines.length === 0) return [];

    if (lines.length === 1 && lines[0].split(' : ').length > 2) {
      return parseSingleLine(lines[0]);
    }

    return lines.map(parseLine).filter(Boolean);
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderRows(rows) {
    return rows
      .map(function (row) {
        return (
          '<div class="nutrition-row">' +
          '<span class="nutrition-label"><p>' + escapeHtml(row.label) + '</p></span>' +
          '<span class="nutrition-value"><p>' + escapeHtml(row.value) + '</p></span>' +
          '</div>'
        );
      })
      .join('');
  }

  class NutritionTable extends HTMLElement {
    connectedCallback() {
      const raw = this.dataset.nutrition;
      if (!raw) return;

      const rows = parseNutrition(raw);
      if (!rows.length) {
        this.innerHTML = '<p>' + escapeHtml(raw) + '</p>';
        return;
      }

      this.innerHTML = renderRows(rows);
    }
  }

  if (!customElements.get('nutrition-table')) {
    customElements.define('nutrition-table', NutritionTable);
  }
})();
